import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css"
import "../../../assets/css/admin/allAdmins.module.css"
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import moment from "moment";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'


const Materials = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [admins,setAdmins]=useState([])

  const getExams=()=>{
    axios.get(`${baseUrl}/material/all-admin`)
    .then(res=>setAdmins(res.data))
    .catch(e=>console.log(e))
  }
  useEffect(()=>{
    getExams()
  },[])

  const deleteCourse=(a)=>{
    swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          axios.post(`${baseUrl}/material/delete/?id=${a._id}&filePath=${a.file}&imgFilePath=${a.image}`)
            .then(res=>{
              getExams()
                swal("Material has been deleted!", {
                    icon: "success",
                  });
                }
            )
          
        } 
      });
}

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">
                All Materials
              </li>
              <li className="breadcrumb-item">
                <Link to='/admin/material/add' className="text-decoration-none">Add</Link>
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div className={`container ${styles.container}`}>
                  <h4 className="mb-4"> All Materials</h4>
          <div style={{overflowX:'scroll'}}>
            <table>
              <thead>
                <tr>
                  <td>ID</td>
                  <td style={{minWidth:'140px'}}>Class</td>
                  <td style={{minWidth:'215px'}}>Title</td>
                  <td>Status</td>
                  <td style={{minWidth:'117px'}}>Start Date</td>
                  <td style={{minWidth:'117px'}}>End Date</td>
                  <td>Price</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                {admins.length > 0 &&
                  admins.map((a, i) => (
                    <tr key={i}>
                      <td>{a.courseID}</td>
                      <td>{a.className}</td>
                      <td>{a.title}</td>
                      <td>{a.active?'Active':'Inactive'}</td>
                      <td>{moment(a.startDate).format('D MMM YYYY')}</td>
                      <td>{moment(a.endDate).format('D MMM YYYY')}</td>
                      <td>{a.price}</td>
                      <td>
                        <Link to={`/admin/material/edit/${a._id}`}><button className="btn btn-success btn-sm m-1 p-1">Edit</button></Link>&nbsp;
                        <button onClick={()=>deleteCourse(a)} className="btn btn-danger btn-sm m-1 p-1">Delete</button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Materials;
